import React, { useEffect } from "react";
import Sidebar from "./Sidebar/Sidebar";
import { useNavigate } from "react-router-dom";

const Setting = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem("professionalToken")) {
      navigate("/professional/login");
      window.location.reload();
    }
  }, []);

  return (
    <div className="pro-app-page pro-app-page--muted">
      <div className="custom_container pro-settings-page">
        <Sidebar />
      </div>
    </div>
  );
};

export default Setting;
